// extracted by mini-css-extract-plugin
export default {"HumidityWrapper":"Humidity_HumidityWrapper__BD1cC","HumidityText":"Humidity_HumidityText__YNFmU","UnitsText":"Humidity_UnitsText__uQM6N"};